import Swiper from 'swiper/bundle';
import { Grid, Navigation } from 'swiper';

Swiper.use([Navigation, Grid]);

function setSliderWidth(fromSelector, toSelector) {
  const fromEl = document.querySelector(fromSelector);
  const toEl = document.querySelector(toSelector);
  const label = document.querySelector('.section-label-block');

  if (!fromEl || !toEl || !label) return;

  const bodyWidth = document.body.clientWidth;
  const ml = parseInt(getComputedStyle(fromEl).marginLeft, 10) || 0;
  const labelWidth = label.offsetWidth || 0;

  const size = bodyWidth - ml - labelWidth;
  toEl.style.width = `${size}px`;
}

function updateSlidersWidth() {
  if (document.querySelector('.relatedPostsSlider')) {
    setSliderWidth('.js-related-container', '.js-related-posts-wrap');
  }
  if (document.querySelector('.packagesServices')) {
    setSliderWidth('.js-packages-container', '.js-packages-slider-wrap');
  }
  if (document.querySelector('.projects')) {
    setSliderWidth('.js-portfolio-container', '.js-portfolio-slider-wrap');
  }
  if (document.querySelector('.relatedServices')) {
    setSliderWidth('.js-services-container', '.js-services-slider-wrap');
  }
}

/**
 * Throttle для resize
 */
let resizeTimeout;
window.addEventListener('load', updateSlidersWidth);
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(updateSlidersWidth, 150);
});

document.addEventListener('DOMContentLoaded', () => {
  // Testimonials
  const swiperLeft = new Swiper('.testimonialsLeftSlider', {
    effect: 'fade',
    allowTouchMove: false,
    fadeEffect: { crossFade: true },
    speed: 600
});

const swiperRight = new Swiper('.testimonialsRightSlider', {
    speed: 600,
    slidesPerView: 1,
    navigation: {
        nextEl: '#ts-btn-next',
        prevEl: '#ts-btn-prev'
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    on: {
        slideChange: function () {
            swiperLeft.slideTo(this.activeIndex);
        }
    }
});


  // Related Services
  if (document.querySelector('.relatedServices')) {
    new Swiper('.relatedServices', {
      loop: false,
      slidesPerView: 4.8,
      spaceBetween: 29,
      navigation: {
        nextEl: '#s-btn-next',
        prevEl: '#s-btn-prev'
      },
      breakpoints: {
        0: {
          loop: false
        },
        575: {
          loop: false,
          slidesPerView: 'auto'
        }
      }
    });
  }

  // Projects
  if (document.querySelector('.projects')) {
    new Swiper('.projects', {
      pagination: {
        el: '.js-portfolio-swiper-pagination',
        clickable: true
      },
      slidesPerView: 3.3,
      spaceBetween: 0,
      loop: false,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: '#btn-next',
        prevEl: '#btn-prev'
      },
      breakpoints: {
        0: {
          slidesPerView: 1
        },
        575: {
          slidesPerView: 2.3
        },
        1024: {
          slidesPerView: 3.3
        },
      }
    });
  }

  // Packages
  if (document.querySelector('.packagesServices')) {
    new Swiper('.packagesServices', {
      slidesPerView: 'auto',
      loop: false,
      spaceBetween: 0,
      navigation: {
        nextEl: '#p-btn-next',
        prevEl: '#p-btn-prev'
      },
      pagination: {
        el: '.js-packages-swiper-pagination',
        clickable: true
      },
      observer: true,
      observeParents: true
    });
  }

  // Related Posts
  if (document.querySelector('.relatedPostsSlider')) {
    new Swiper('.relatedPostsSlider', {
      loop: false,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: '#rp-btn-next',
        prevEl: '#rp-btn-prev'
      },
      pagination: {
        el: '.js-related-posts-swiper-pagination',
        clickable: true
      },
      slidesPerView: 'auto'
    });
  }

  // Benefits (Grid)
  if (document.querySelector('.js-benefits-swiper')) {
    new Swiper('.js-benefits-swiper', {
      pagination: {
        el: '.js-benefits-swiper-pagination',
        clickable: true
      },
      navigation: {
          nextEl: "#benefits-next",
          prevEl: "#benefits-prev",
      },
      loop: false,
      slidesPerView: 1.18,
      grid: {
        rows: 1
      },
      spaceBetween: 63,
      breakpoints: {
        0: {
          spaceBetween: 70,
          slidesPerView: 1
        },
        576: {
          spaceBetween: 63,
          slidesPerView: 1.3
        },
        1025: {
          spaceBetween: 63,
          slidesPerView: 2.1
        }
      }
    });
  }

  // Core Values (Grid)
  document.querySelectorAll('.js-core-values-swiper').forEach((slider) => {
    const container = slider.closest('.core-values');

    if (!container) return;

    new Swiper(slider, {
      pagination: {
        el: container.querySelector('.js-core-values-swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: container.querySelector('#core-values-next'),
        prevEl: container.querySelector('#core-values-prev')
      },
      loop: false,
      slidesPerView: 1.18,
      grid: {
        rows: 1
      },
      spaceBetween: 63,
      breakpoints: {
        0: {
          spaceBetween: 70,
          slidesPerView: 1
        },
        576: {
          spaceBetween: 63,
          slidesPerView: 1.3
        },
        1024: {
          slidesPerView: 2.1
        }
      }
    });
  });
});

const testimonialsSlider = new Swiper('.testimonialsSlider', {
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    navigation: {
        nextEl: '.js-ts-btn-next',
        prevEl: '.js-ts-btn-prev'
    },
    pagination: {
        el: '.js-testimonials-swiper-pagination',
        type: 'fraction',
    },
    loop: true,
});